import React from 'react';
import { RoleActiveTools } from '@/components/ai/RoleActiveTools';

/**
 * Guardian Active Tools Page
 * Shows the guardian's (parent's) active AI tools from the marketplace
 */
export default function GuardianAiTools() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-6">
      <RoleActiveTools
        role="guardian"
        title="Your AI Tools"
        description="Launch your active AI tools to help stay connected with your child's education and communicate with teachers."
        marketplacePath="/portal/guardian/ai-marketplace"
        showComingSoon={true}
      />
    </div>
  );
}
